module.exports = __webpack_public_path__ + "img/dwhc.e83ad494.png";